import React from 'react'
import PropTypes from 'prop-types'
import { List } from 'antd'
import Item from './Item'
import { withProductionProgressContext } from '../../contexts'

const ProductionProgress = ({ items }) => {
  const existItems = !!items && items.length > 0

  return existItems
    ? (
      <List
        dataSource={items}
        bordered
        renderItem={item => <Item item={item} key={item.id}/>}
      />
    )
    : null
}

ProductionProgress.propTypes = {
  items: PropTypes.array
}

export default withProductionProgressContext(context => ({
  items: context.items,
}))(ProductionProgress)
